<template>
	<component
		:is="activityComponent"
		:activity="activity"
		@click="onClick"
	/>
</template>

<script>
import { KeyResultActivityType } from "@teaming/common-enums";

import KRCommentActivity from "./KRCommentActivity.vue";
import KRConfidenceActivity from "./KRConfidenceActivity.vue";
import KRCreationActivity from "./KRCreationActivity.vue";
import KRNameActivity from "./KRNameActivity.vue";
import KROwnerActivity from "./KROwnerActivity.vue";
import KRProgressActivity from "./KRProgressActivity.vue";
import KRSortOrderActivity from "./KRSortOrderActivity.vue";
import KRTypeActivity from "./KRTypeActivity.vue";
import UnknownActivity from "../Activity/UnknownActivity.vue";

const componentMap = {
	KEY_RESULT: {
		[ KeyResultActivityType.COMMENT ]: "KRCommentActivity",
		[ KeyResultActivityType.CONFIDENCE ]: "KRConfidenceActivity",
		[ KeyResultActivityType.CREATE ]: "KRCreationActivity",
		[ KeyResultActivityType.NAME ]: "KRNameActivity",
		[ KeyResultActivityType.OWNER ]: "KROwnerActivity",
		[ KeyResultActivityType.PROGRESS ]: "KRProgressActivity",
		[ KeyResultActivityType.SORT_ORDER ]: "KRSortOrderActivity",
		[ KeyResultActivityType.TYPE ]: "KRTypeActivity",
	},
};

/**
 * Meta-component for activity entries.
 */
export default {
	name: "KeyResultActivity",
	emits: [ "action", ],
	components: {
		KRCommentActivity,
		KRConfidenceActivity,
		KRCreationActivity,
		KRNameActivity,
		KROwnerActivity,
		KRProgressActivity,
		KRSortOrderActivity,
		KRTypeActivity,
		UnknownActivity,
	},
	props: {
		activity: {
			type: Object,
			required: true,
			validator( activity ) {
				const { discriminator = "", activityType = "", } = activity;
				if ( discriminator !== "KEY_RESULT" ) {
					return false;
				}
				return KeyResultActivityType.includes( activityType );
			},
		},
	},
	computed: {
		activityComponent() {
			const { discriminator, activityType, } = this.activity;
			return componentMap?.[ discriminator ]?.[ activityType ] || "UnknownActivity";
		},
	},
	methods: {
		onClick( e ) {
			const { activity, } = this;
			const { action, } = e.target.dataset;
			if ( action ) {
				this.$emit( "action", { action, activity, } );
				e.preventDefault();
				e.stopPropagation();
			}
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
